import FloodgateStorageProvider from "../FloodgateCore/FloodgateStorageProvider";
import * as Utils from "../Utils";
import { FileType } from "@ms-ofb/officefloodgatecore/dist/src/Api/IFloodgateStorageProvider";
const {
  isNOU
} = Utils;
export class TargetedMessagingCache {
  constructor(items) {
    this.useLocalStorage = false;
    this.cachedItems = {};
    this.initialize(items);
  }
  setContentItem(contentType, content, expiryTime) {
    const cacheItem = this.createItem(contentType, content, expiryTime);
    this.setItem(cacheItem);
    return cacheItem;
  }
  getItemContent(contentType) {
    const cacheItem = this.getItem(contentType);
    return cacheItem && cacheItem.content;
  }
  has(contentType) {
    return contentType in this.cachedItems;
  }
  isItemExpired(contentType) {
    const cacheItem = this.getItem(contentType);
    return !cacheItem || !cacheItem.expiryDate || cacheItem.expiryDate < new Date();
  }
  createItem(contentType, content, expiryTime) {
    const cacheItem = {
      contentType,
      content,
      expiryDate: new Date(Date.now() + expiryTime),
      lastRetrievedDate: new Date()
    };
    return cacheItem;
  }
  setItem(cacheItem) {
    this.cachedItems[cacheItem.contentType] = cacheItem;
    this.updateItemInLocalStorage(cacheItem);
  }
  getItem(contentType) {
    return this.cachedItems[contentType];
  }
  initialize(items) {
    this.cachedItems = {};
    if (FloodgateStorageProvider.isStorageAvailable()) {
      this.floodgateStorage = new FloodgateStorageProvider();
      this.useLocalStorage = true;
      // try to fetch items from local storage if available from prior sessions
      this.initCachedItemsFromLocalStorage(items);
    } else {
      // no LocalStorage support, only active object cache only
    }
  }
  initCachedItemsFromLocalStorage(items) {
    if (this.useLocalStorage) {
      if (!isNOU(items)) {
        for (let contentKey of items) {
          let tempStorageItem = this.floodgateStorage.read(this.mapContentTypeToFloodgateProviderKey(contentKey));
          if (!isNOU(tempStorageItem)) {
            const tempCacheItem = this.parseObjectFromCache(tempStorageItem);
            if (!isNOU(tempCacheItem)) {
              tempCacheItem.expiryDate = typeof tempCacheItem.expiryDate === "string" ? new Date(tempCacheItem.expiryDate) : tempCacheItem.expiryDate;
              this.cachedItems[tempCacheItem.contentType] = tempCacheItem;
            }
          }
        }
      }
    }
  }
  updateItemInLocalStorage(cacheItem) {
    if (this.useLocalStorage) {
      this.floodgateStorage.write(this.mapContentTypeToFloodgateProviderKey(cacheItem.contentType), JSON.stringify(cacheItem));
    }
  }
  parseObjectFromCache(tempItem) {
    try {
      const tempCacheItem = JSON.parse(tempItem);
      return tempCacheItem;
    } catch (e) {
      return null;
    }
  }
  mapContentTypeToFloodgateProviderKey(contentType) {
    switch (contentType) {
      case "CampaignContent" /* campaignContent */:
        return FileType.TmsCache_CampaignContent;
      case "MessageMetadata" /* messageMetadata */:
        return FileType.TmsCache_MessageMetadata;
      case "UserGovernance" /* userGovernanceRules */:
        return FileType.TmsCache_UserGovernance;
      case "DynamicSettings" /* dynamicSettings */:
        return FileType.Tms_DynamicSettings;
      case "LogLevelSettings" /* logLevelSettings */:
        return FileType.LogLevelSettings;
      case "UserFacts" /* userFacts */:
        return FileType.UserFacts;
      default:
        throw new Error("Unmapped ContentType in TmsCache");
    }
  }
}